// @ts-nocheck
import React from 'react'
import cx from 'classnames'
import * as R from 'ramda'

import styles from './Loader.module.scss'

export const Loader = ({
  isBig = false,
  isInline = false,
  isFullScreen = false,
  ...props
}) => (
  <span
    className={cx(styles.loader, {
      [styles.big]: isBig,
      [styles.inline]: isInline,
      [styles.isFullScreen]: isFullScreen,
    })}
    data-testid="loader"
  >
    <span className={styles.content} {...props}>
      {R.map(
        key => (
          <span className={styles.dot} key={key} />
        ),
        [0, 1, 2, 3],
      )}
    </span>
  </span>
)
